var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var UnionConfig_1;
import { ToolType } from '@symon-ai/wisepipe-base-pipe';
import { JSON, JsonDiscriminatorValue, JsonSchema } from '@symon-ai/wisepipe-serialize';
import { EdgeElement } from './edgeElement';
import { MultiUnionConfig } from './multiUnionConfig';
import { ToolCategories } from './toolCategories';
import { ToolConfig } from './toolConfig';
import { ToolConfigInfo } from './toolConfigInfo';
import { ToolScopeBuilder } from './toolScopeBuilder';
import { ToolValidationResult, ToolValidationState } from './validation/toolValidationResult';
const schema = {
    $id: 'urn:wisepipe-common-pipe:UnionConfig',
    type: 'object',
    properties: {}
};
let UnionConfig = UnionConfig_1 = class UnionConfig extends ToolConfig {
    constructor(customFormats) {
        super(ToolType.UNION, customFormats);
        JSON.validate(this, UnionConfig_1);
    }
    // eslint-disable-next-line class-methods-use-this
    get top() {
        return UnionConfig_1.top;
    }
    // eslint-disable-next-line class-methods-use-this
    get bottom() {
        return UnionConfig_1.bottom;
    }
    get out() {
        return this.outs[0];
    }
    // eslint-disable-next-line class-methods-use-this
    get ins() {
        return UnionConfig_1.ins;
    }
    // eslint-disable-next-line class-methods-use-this
    get outs() {
        return UnionConfig_1.outs;
    }
    static get top() {
        return UnionConfig_1.ins[0];
    }
    static get bottom() {
        return UnionConfig_1.ins[1];
    }
    static get ins() {
        return ['top', 'bottom'];
    }
    static get outs() {
        return ['default'];
    }
    static get info() {
        return new ToolConfigInfo(ToolType.UNION.split('_')
            .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
            .join(' '), [ToolCategories.COMBINE], this.ins, this.outs, ['merge', 'combine', 'match', 'append rows'], true);
    }
    getOutput(iConfigHelper, ins) {
        const tsb = new ToolScopeBuilder(ins);
        const top = ins.schemas.at(this.top);
        const bottom = ins.schemas.at(this.bottom);
        const common = UnionConfig_1.getMatchingColumns(top, bottom);
        const exp = tsb.export(this.out);
        common.forEach((c) => {
            exp.copy(this.top, c, true, false, [bottom.find((b) => b.name === c.name)]);
        });
        exp.initializeColumnFormats().setColumnFormats(this.customFormats);
        return tsb.build();
    }
    isValidForCalc(iConfigHelper, scope) {
        const toolValidationResult = this.getToolValidationResult(iConfigHelper, scope);
        return toolValidationResult.validationState;
    }
    getToolValidationResult(iConfigHelper, scope) {
        const top = scope.schemas.at(this.top);
        const bottom = scope.schemas.at(this.bottom);
        if (!top || !bottom)
            return ToolValidationResult.getPortMissingEdgesResult('One or more input nodes are missing.', 'The union tool requires two input nodes.');
        return UnionConfig_1.getMatchingColumns(top, bottom).length > 0
            ? ToolValidationResult.getValidResult()
            : ToolValidationResult.getBadMetadataResult('No matching columns found between the two input nodes.', 'The union tool requires at least one column with the same name and type in both input nodes.');
    }
    isValidForRun(iConfigHelper, scope, pass) {
        return pass ? ToolValidationState.BAD_METADATA : this.isValidForCalc(iConfigHelper, scope);
    }
    static getMatchingColumns(top, bottom) {
        const matchingColumns = [];
        // WP-9205: if there are any column with a matching name and type, then we can union that column
        for (const bColumn of bottom) {
            const matches = top.filter((tColumn) => tColumn.name === bColumn.name && tColumn.type === bColumn.type);
            matchingColumns.push(...matches);
        }
        return matchingColumns;
    }
    updateToolConfig(config) {
        return new MultiUnionConfig(config.customFormats);
    }
    updateIns(edge, edgeIDs) {
        const idx = edgeIDs.indexOf(edge.elementID);
        return new EdgeElement(edge.elementID, edge.srcElementID, edge.srcPort, edge.tarElementID, `multi_${idx}`);
    }
    updateOuts(edge) {
        return new EdgeElement(edge.elementID, edge.srcElementID, edge.srcPort, edge.tarElementID, edge.tarPort);
    }
};
UnionConfig = UnionConfig_1 = __decorate([
    JsonSchema(schema),
    JsonDiscriminatorValue(ToolType.UNION)
], UnionConfig);
export { UnionConfig };
//# sourceMappingURL=unionConfig.js.map